import { useState } from 'react';
import { useDatos } from '../../datos/DatosContext';
import { useRuta } from '../../lib/ruta';
import { useAviso } from '../../lib/avisos';
import { nuevoId } from '../../lib/fechas';
import { Icono } from '../../componentes/ui/Icono';
import { Cabecera, Demo, GrupoChips, Volver } from '../../componentes/ui/basicos';

const alternar = (lista: string[], v: string) => (lista.includes(v) ? lista.filter((x) => x !== v) : [...lista, v]);

export function SuenoNuevo() {
  const { datos, agregar } = useDatos();
  const { ir } = useRuta();
  const aviso = useAviso();
  const [titulo, setTitulo] = useState('');
  const [relato, setRelato] = useState('');
  const [fecha, setFecha] = useState('');
  const [emociones, setEmociones] = useState<string[]>([]);
  const [simbolos, setSimbolos] = useState<string[]>([]);
  const [permitirIA, setPermitirIA] = useState(false);

  const guardar = () => {
    if (!relato.trim() && !titulo.trim()) { aviso('Escribe al menos el relato o un título.'); return; }
    const id = nuevoId('s');
    const tituloFinal = titulo.trim() || relato.trim().split(/\s+/).slice(0, 5).join(' ') + '…';
    agregar('suenos', { id, titulo: tituloFinal, fecha, emociones, simbolos, permitirIA, relato: relato.trim(), reflexionPropia: '', reflexionIAAprobada: '' });
    aviso('Sueño guardado (solo en esta sesión).');
    ir('/suenos/' + id);
  };

  return (
    <div className="stack-lg">
      <Volver a="/suenos">Sueños</Volver>
      <Cabecera antetitulo="Nuevo sueño" titulo="¿Qué soñaste?" subtitulo="Solo el relato es importante. Lo demás, si te apetece." />
      <div className="card stack">
        <div className="field">
          <label htmlFor="nd-relato">Relato</label>
          <textarea id="nd-relato" rows={6} placeholder="Escribe como te salga, sin corregir…" value={relato} onChange={(e) => setRelato(e.target.value)} />
        </div>
        <div>
          <button className="btn" onClick={() => aviso('Solo visual: la grabación y transcripción de voz llegarán en una fase posterior.')}>
            <Icono nombre="mic" />Dictar con la voz <Demo>Fase posterior</Demo>
          </button>
        </div>
        <div className="grid2">
          <div className="field">
            <label htmlFor="nd-titulo">Título breve (opcional)</label>
            <input id="nd-titulo" type="text" placeholder="Por ejemplo: El tren azul" value={titulo} onChange={(e) => setTitulo(e.target.value)} />
          </div>
          <div className="field">
            <label htmlFor="nd-fecha">Fecha (opcional)</label>
            <input id="nd-fecha" type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
          </div>
        </div>
        <div className="stack-sm">
          <span className="lbl">Emociones (opcional)</span>
          <GrupoChips etiqueta="Emociones del sueño" opciones={datos.opciones.emocionesSuenos} seleccion={emociones} onElegir={(v) => setEmociones((l) => alternar(l, v))} />
        </div>
        <div className="stack-sm">
          <span className="lbl">Símbolos o temas (opcional)</span>
          <GrupoChips etiqueta="Símbolos del sueño" opciones={datos.opciones.simbolosSuenos} seleccion={simbolos} onElegir={(v) => setSimbolos((l) => alternar(l, v))} />
        </div>
        <div className="locked-box between">
          <div>
            <p style={{ margin: 0, fontWeight: 600 }}>Permitir consulta IA</p>
            <p className="small muted" style={{ margin: '2px 0 0' }}>Desactivado por defecto. Puedes cambiarlo cuando quieras.</p>
          </div>
          <button className={permitirIA ? 'chip on' : 'chip'} aria-pressed={permitirIA} onClick={() => setPermitirIA((v) => !v)}>
            {permitirIA ? 'Permitida' : 'No permitida'}
          </button>
        </div>
        <div className="row" style={{ justifyContent: 'flex-end' }}>
          <button className="btn" onClick={() => ir('/suenos')}>Cancelar</button>
          <button className="btn primary" onClick={guardar}>Guardar sueño</button>
        </div>
      </div>
    </div>
  );
}
